import { getPersistConfig } from '@ms/yammer-data/dist/persistedState';
import type { PersistConfig } from 'redux-persist';

import type { YammerEmbedState } from '../../state/types';

export const persistConfig: PersistConfig<YammerEmbedState> = getPersistConfig<YammerEmbedState>({
  key: 'embed',
  allowlist: ['ecsConfig', 'ecsExperiments', 'ecsFeatureRollouts'],
});
